import { render, staticRenderFns } from "./Perfiles.vue?vue&type=template&id=ccf0fe98&scoped=true"
import script from "./Perfiles.vue?vue&type=script&lang=js"
export * from "./Perfiles.vue?vue&type=script&lang=js"
import style0 from "./Perfiles.vue?vue&type=style&index=0&id=ccf0fe98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf0fe98",
  null
  
)

export default component.exports